export const PROJECT_PATH_SEPARATOR: string = '/' // ' > '